import React, { useState, useContext } from "react";
import { Field, Formik } from "formik";
import { get, isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { faToggleOn } from "@fortawesome/pro-solid-svg-icons";
import { faToggleOff } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputPassword,
  FieldInputSSN,
  SearchableList,
  ManageMapperLayout,
  LoaderWrapper,
  FieldInputNumber,
  UploadComponent,
} from "../../../components";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  FLOW_TYPES,
  ROUTES,
  fileFormatData,
  required,
} from "../../../utils";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  manageMapperStore,
  setBasicInformation,
  setManageMapperPageLevelData,
  setManageMapperToastInfo,
  setMapperPageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperTargetStep,
  setFileUploadData,
  setOldFileName,
  setMapperPostResponse,
  UploadTargetFile,
} from "../../../contexts";
import {
  onSavePassthroughTarget,
  getTargetModelValues,
  onSaveTarget,
} from "../../../services";
import groupIcon from "../../../assets/icons/svg/Group.svg";
import group2 from "../../../assets/icons/svg/Group_8345.svg";

const Target = (props) => {
  const initialValues = {
    FileFormat: "",
    FURL: "",
    FPath: "",
    FUserName: "",
    FPassword: "",
    fileType: get(data, "fileType", 1),
  };

  const { flow, profileId, mapType } = useRouterParams();
  const { state, dispatch } = useContext(manageMapperStore);
  const apiData = get(state, "api.data", []);
  const api = get(state, "api", []);

  const targetStep = get(api, "targetStep");
  const editable = get(targetStep, "targetStep") == 3;
  //const targetStepp=x.targetStep;

  const isEdit = flow === FLOW_TYPES.EDIT;

  const uploadedData = isEmpty(get(state, "EditedTargetDataCreate", {}))
    ? get(state, "api.data", {})
    : get(state, "EditedTargetDataCreate", {});
  const uploadType = get(uploadedData, "uploadedFileType");

  const headersJson = get(apiData, "headerMapJson", []);
  const fileuploadData = get(state, "api.fileuploadData", []);
  const formValues = get(state, "api.fileuploadData")
    ? get(state, "api.fileuploadData.mappingConfiguration", {})
    : get(state, "api.data", {});
  const fieldHeadersJson = isEmpty(fileuploadData)
    ? get(state, "api.data", {})
    : get(state, "api.fileuploadData.mappingConfiguration", []);
  const data = {
    ...fieldHeadersJson,
    ...get(state, "EditedTargetDataCreate", {}),
  };
  const enableAutoMapper = get(fieldHeadersJson, "enableAutomapper");
  const [flag, setFlag] = useState({});
  const [DCFormatOptions, setDCFormatOptions] = useState([]);
  useDeepEffect(() => {
    setFlag(enableAutoMapper);
  }, [enableAutoMapper]);
  useDeepEffect(() => {
    getTargetModelValues().then((response) => {
      setDCFormatOptions(
        response.map((res) => ({
          label: res.dataModelValue,
          value: res.id,
          assemblyName: res.assemblyName,
          namespace: res.namespace,
        }))
      );
    });
  }, []);
  const onCheckboxClick = () => {
    setFlag(!flag);
  };
  const [dataLoading, setDataLoading] = useState(false);
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];

  const [requireFTP, setRequireFTP] = useState(true);

  const yesNoOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];

  const targetFields = [
    {
      label: "Upload File",
      value: 1,
    },
    {
      label: "Create New",
      value: 2,
    },
  ];

  const typeOptions = [
    { value: 0, label: "CORE" },
    { value: 1, label: "File" },
  ];

  // const DCFormatoptions = [
  //   { value: 3, label: "DC - Payroll & Census" },
  //   { value: 2, label: "DC - Payroll" },
  //   { value: 1, label: "DC - Census" },
  //   { value: 4, label: "DC - Loan" },
  // ];

  const FileFormOptions = [
    { value: 0, label: "Excel" },
    { value: 1, label: "CSV" },
    { value: 2, label: "JSON" },
    { value: 3, label: "XML" },
    { value: 4, label: "Fixed Width" },
  ];
  function onSubmit(values) {
    setDataLoading(true);
    const { history } = props;
    const isCOREProfile = get(values, "isCOREDCProfile") ? false : true;
    onSaveTarget({
      ...data,
      isCOREDCProfile: isCOREProfile,
      uploadedFileType: get(values, "uploadedFileType", 3),
      enableAutomapper: flag,
      assemblyName: DCFormatOptions.find(
        (_) => _.value == get(values, "uploadedFileType")
      ).assemblyName,
      namespace: DCFormatOptions.find(
        (_) => _.value == get(values, "uploadedFileType")
      ).namespace,
      ftpChannel:
        values != null
          ? {
              channelType: 0,
              url: get(values, "FURL"),
              filePath: get(values, "FPath"),
              userName: get(values, "FUserName"),
              password: get(values, "FPassword"),
            }
          : null,
    })
      .then((res) => {
        setDataLoading(false);

        if (!isEmpty(res)) {
          dispatch(
            setMapperPageLevelData({
              formName: "EditedTargetDataCreate",
              fieldData: {
                isCOREDCProfile: isCOREProfile,
                uploadedFileType: get(values, "uploadedFileType", 3),

                // ftpChannel: !isCOREProfile
                ftpChannel:
                  values != null
                    ? {
                        channelType: 0,
                        url: get(values, "FURL"),
                        filePath: get(values, "FPath"),
                        userName: get(values, "FUserName"),
                        password: get(values, "FPassword"),
                      }
                    : null,
              },
              format: data.format
                ? data.format
                : fileuploadData.mappingConfiguration.format,
            })
          );
          dispatch(
            setManageMapperPageLevelData({
              formName: "uploadedFileType",
              fieldData: get(values, "uploadedFileType", 3),
            })
          );
          dispatch(
            setManageMapperTargetStep({
              targetStep: 3,
            })
          );
          dispatch(
            setFileUploadData({
              mappingConfiguration: res,
            })
          );
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          history.push(
            `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM}/${mapType}/${profileId}`
          );
        } else {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        }
      })
      .catch((err) => {
        setDataLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
    // }

    // if (isEdit) {
    //   history.push(
    //     `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM}/edit/${mapType}/${profileId}`
    //   );
    // }
  }
  return (
    <Formik
      initialValues={{
        ...initialValues,
        isCOREDCProfile: get(data, "isCOREDCProfile") ? 0 : 1,
        uploadedFileType: uploadType || 3,
        FURL: get(data, "ftpChannel.url"),
        FPath: get(data, "ftpChannel.filePath"),
        FUserName: get(data, "ftpChannel.userName"),
        FPassword: get(data, "ftpChannel.password"),
        enableAutomapper: get(data, "enableAutomapper"),
      }}
      enableReinitialize
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setValues,
        handleChange,
        setFieldValue,
        handleSubmit,
      }) => {
        return (
          <LoaderWrapper
            isLoading={dataLoading}
            isAutoMapper={flag && !(get(apiData, "step") > 3)}
          >
            <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
              <ManageMapperLayout buttons={buttons}>
                <div>
                  <Field
                    name="isCOREDCProfile"
                    label={"Type"}
                    value={values["isCOREDCProfile"]}
                    options={typeOptions}
                    isRequired
                    direction={"bottom"}
                    disabled={isEdit || editable}
                    popupContent={
                      <SearchableList
                        label="Type"
                        isNotTypeAhead
                        options={typeOptions}
                        onSelect={(value) =>
                          setFieldValue("isCOREDCProfile", value)
                        }
                        selectedValue={values["isCOREDCProfile"]}
                      />
                    }
                    component={FieldDropSide}
                  />

                  {values.isCOREDCProfile === 1 ? (
                    <div>
                      <div
                        style={{
                          width: "20rem",
                          fontSize: "14px",
                          // font: "Poppins",
                          fontWeight: "400",
                        }}
                      >
                        <Field
                          name={"DCFormat"}
                          label={"File Format"}
                          value={values["DCFormat"]}
                          options={FileFormOptions}
                          isRequired
                          direction={"bottom"}
                          popupContent={
                            <SearchableList
                              label="File Format"
                              isNotTypeAhead
                              options={FileFormOptions}
                              onSelect={(value) =>
                                setFieldValue("DCFormat", value)
                              }
                              selectedValue={values["DCFormat"]}
                            />
                          }
                          component={FieldDropSide}
                        />
                        <div>
                          <div
                            className="FTPDetailsText"
                            style={{
                              paddingTop: "1.5rem",
                              paddingBottom: "0.5rem",
                            }}
                          >
                            FTP Details
                          </div>

                          <div className="FTPFieldsText">Requires FTP</div>
                          <Field
                            isRequired
                            name="FTP require"
                            size="md"
                            className="bg-transparent p-0"
                            options={yesNoOptions}
                            selectedValue={requireFTP}
                            onChange={(value) => {
                              setRequireFTP(value);
                              values.FURL = "";
                              values.FPath = "";
                              values.FUserName = "";
                              values.FPassword = "";
                            }}
                            component={FieldButtonGroup}
                          />

                          {requireFTP && (
                            <div
                              style={{ width: "20rem", paddingTop: "0.5rem" }}
                            >
                              <Field
                                name="FURL"
                                placeholder={"eg : ftp://yourname@host.dom/"}
                                label={"FTP URL"}
                                noLabelTransform
                                component={FieldInput}
                                isRequired
                              />

                              <Field
                                name="FPath"
                                placeholder={
                                  "eg : ftp.yourname@host.dom/batchfile"
                                }
                                label={"FTP path"}
                                noLabelTransform
                                component={FieldInput}
                                isRequired
                              />

                              <Field
                                name="FUserName"
                                placeholder={"Enter UserName"}
                                label={"UserName"}
                                noLabelTransform
                                component={FieldInput}
                                isRequired
                              />
                              <Field
                                name="FPassword"
                                placeholder={"Enter Password"}
                                label={"Password"}
                                noLabelTransform
                                component={FieldInputPassword}
                                isRequired
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <Field
                        name="uploadedFileType"
                        label={"Data Model"}
                        value={values["uploadedFileType"]}
                        options={DCFormatOptions}
                        isRequired
                        disabled={isEdit || editable}
                        direction={"rightSide"}
                        popupContent={
                          <SearchableList
                            label={"Select a data model"}
                            isNotTypeAhead
                            options={DCFormatOptions}
                            onSelect={(value) =>
                              setFieldValue("uploadedFileType", value)
                            }
                            selectedValue={values["uploadedFileType"]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      {process.env.REACT_APP_ENABLE_AUTO_MAPPER === "true" && (
                        <>
                          <div
                            style={{
                              fontWeight: "600",
                              font: "open-sans",
                              marginBottom: "20px",
                              fontsize: "20px",
                              marginTop: "30px",
                            }}
                          >
                            Automap
                          </div>
                          <div
                            className="automap-container"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "8px",
                            }}
                          >
                            <div>
                              <img src={group2} alt="Image 1" />
                            </div>
                            <div>
                              <img
                                src={groupIcon}
                                alt="Image 2"
                                style={{
                                  marginTop: "-10px",
                                  marginLeft: "0px",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                marginLeft: "25px",
                                marginTop: "0px",
                                fontWeight: "600",
                                fontSize: "15px",
                                color: "#242426",
                              }}
                            >
                              Instant Field Mapping: One Click, Done!
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Form.Check
                                  custom
                                  id="enableAutomapper"
                                  name="enableAutomapper"
                                  type="switch"
                                  autoFocus="off"
                                  onChange={onCheckboxClick}
                                  checked={flag}
                                  disabled={get(apiData, "step") >= 4}
                                  className={
                                    get(apiData, "step") >= 4
                                      ? "mappercursor-notallowed"
                                      : "medium"
                                  }
                                />
                                <div
                                  style={{
                                    marginLeft: "20px",
                                    fontWeight: "600",
                                    color: "#919191",
                                  }}
                                >
                                  {flag ? "Enable" : "Disable"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </ManageMapperLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default Target;
